/** FILE FOR GLOBAL VARIABLES -- this file is at the top of the minified file, so these functions can be used in all js files without having to export them and import in the file */

const MONTHS = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];

const BOOTSTRAP_BREAKPOINTS = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1600,
};

// get the home page url
const WpJsonUrl = document.querySelector('link[rel="https://api.w.org/"]').href;
const homeUrl = WpJsonUrl.replace("/wp-json/", "");

/**
 * commonly used PHP variables to access in JS
 */

const TEMPLATE_DIRECTORY = `${window.location.origin}/wp-content/themes/Endless23`;

// classNames used accross multiple pages

// archives
const paginationPrevPageClassName = "prev_page";
const paginationNextPageClassName = "next_page";
const paginationCurrentPageClassName = "current_page";
